import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';

const CloneRequestModal = ({ isOpen = false, client, onClone, onCancel }) => {
	const modalRef = useRef();
	useEffect(() => {
		if (isOpen) {
			modalRef.current.showModal();
		}
	}, [isOpen]);

	const handleCloneClick = () => {
		onClone();
	};

	return (
		<dialog id="reassign-dialog" className="modal" ref={modalRef}>
			<div className="modal-box">
				<h3>Create Service Request</h3>
				<div className="py-4">
					Would you like to create a new Service Request for{' '}
					{client?.name_first} {client?.name_last}?
				</div>
				<div className="modal-action">
					<form method="dialog">
						<button className="btn" onClick={onCancel}>
							No
						</button>
						<button className="ml-4 btn btn-primary" onClick={handleCloneClick}>
							Yes
						</button>
					</form>
				</div>
			</div>
		</dialog>
	);
};

CloneRequestModal.propTypes = {
	isOpen: PropTypes.bool,
	client: PropTypes.object,
	onClone: PropTypes.func.isRequired,
	onCancel: PropTypes.func.isRequired,
};

export default CloneRequestModal;
